module.exports = __webpack_public_path__ + "media/images/clients/ring-70e013b8c07d9fe0828d111c94f332e7.gif";